import { useAppSelector } from "../../app/hooks";
import { findTint } from "./accessibilityUtil";

interface Props {
	className?: string;
}

export default function TintOverlay(props: Props) {
	const accessibility = useAppSelector((state) => state.user.accessibility);
	if (!accessibility?.tintOverlay) return null;
	const tint = findTint(accessibility.tintOverlay);

	return (
		<div
			className={`${props.className} fixed top-0 left-0 w-screen h-screen opacity-20 pointer-events-none z-[1002]`}
			style={{
				backgroundColor: tint,
			}}></div>
	);
}
